import React from 'react';
import { Dropdown } from 'antd';
import type { DropdownProps } from 'antd';

export type AppDropdownProps = DropdownProps;

const AppDropdown: React.FC<AppDropdownProps> = props => {
  const { classNames, overlayClassName, ...rest } = props;
  const basePopupClassName = ['app-dropdown-ra2n', overlayClassName].filter(Boolean).join(' ');
  const mergedClassNames =
    typeof classNames === 'function'
      ? (info: { props: DropdownProps }) => {
          const resolved = classNames(info);
          return {
            ...resolved,
            root: [basePopupClassName, resolved?.root].filter(Boolean).join(' '),
          };
        }
      : {
          ...classNames,
          root: [basePopupClassName, classNames?.root].filter(Boolean).join(' '),
        };

  return <Dropdown classNames={mergedClassNames} {...rest} />;
};

export default AppDropdown;
